<!-- 平面图 -->
<template>
	<div class="generatechart" data-aos="slide-down" data-aos-delay="0">
        <div v-if="showData.T_plan==''">
			<div class="no-data">  
                <div class="no-data-item">  
                    <div class="no-data-text" style="color: #2F6BCF;">哎呀！暂无数据可展示哦</div>
                </div>
            </div>
		</div>
        <iframe v-else style="width: 100%; flex:1;" :src="`https://vdata.baozhida.cn/admin/View?ProjectID=${showData.T_plan}&Data=${token}`" allowfullscreen="allowfullscreen" frameborder="0" data-id="1"></iframe>
	</div>
</template>

<script>
	import {mapGetters} from "vuex"
	export default {
		computed:mapGetters(["showData"]),
		data() {
			return {
				token:this.$store.state.userInfo.token
			}
		},
		created() {
			////console.log('luj',this.showData.T_plan,this.token)
			// window.open('https://osscold.baozhida.cn/Tool/DataTool.htm','_blank')
		},
		mounted() {
		}
	}
</script>

<style lang="scss">
	.generatechart{
		height: 100%;
	}
</style>
